import { Component, OnInit } from '@angular/core';
import { PermitService } from 'app/services/permit.service';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { ApplicationService } from 'app/services/application.service';
import { StatusService } from 'app/services/status.service';
import { PermitTypeService } from 'app/services/permit-type.service';
import { ToastrService } from 'ngx-toastr';
import { ToastNotificationService } from 'app/shared/toast-notification/toast-notification.service';
import { FilterService } from 'app/shared/filter/filter.service';

@Component({
  selector: 'app-view-permit',
  templateUrl: './view-permit.component.html',
  styleUrls: ['./view-permit.component.css']
})
export class ViewPermitComponent implements OnInit {
  permits: any = [];
gridload:boolean;
pageSize: number = 10;
pageSizeMax: number = 2147483647; // C# Int32.MaxValue
pageNumber: number = 1;
Count: number = 0;
types
isEmpty: boolean = false;
statusesFilter: any = [];
selectedItems: any = [];
dropdownSettings: any = {};
ShowFilter = false;

message = "Processing your request...";

activeItems: any = [];
activeSettings: any = {};
activeShowFilter = false;
actives = [
  { id:1, text: 'Active' },
  { id:0, text: 'Inactive' },
];
category = [
  { id:1, text: 'Select permit type' }
];

carrierName:any = null;
dateFrom:any;
dateTo:any;
status:any;
isActive:any;
permit_type:any = null;
permit_num:any = null;
vehicle_num:any = null;
statuses:any = [];
isActives:any;
date = new Date;
date1 = new Date;

formattedDate
  constructor(private permitService:PermitService,public utility:UtilityServiceService,private toastService:ToastNotificationService,
    private applicationService:ApplicationService,private statusSerevice:StatusService,private filter:FilterService,
    private permitTypService:PermitTypeService, private toaster:ToastrService,) { }

  ngOnInit() {
    this.utility.isPermitEnquiry = true;
    //this.date.setMonth(this.date.getMonth()-1);
    this.date1.setMonth(this.date1.getMonth()+1-1)
    //console.log(this.date1.setMonth(this.date1.getMonth()-1));
    this.formattedDate = this.date1.toISOString().slice(0,10);
    //console.log(this.date1.toISOString().slice(0,10))

   // this.getAppPermits();
    this.getStatus();
    this.InitMultiselect();
    this.getPermitTypes();
    this.InitActiveMultiselect();
   // this.initializeDates();
    this.onSearch();


  }
  initializeDates() {
    //if (this.dateFrom == "" || this.dateTo == "") {
      let g = new Date();
      g.setDate(g.getDate() - 90);

      let mm = (g.getMonth() + 1).toString();
      if (mm.length == 1) {
        mm = "0" + mm;
      }
      let dd = (g.getDate()).toString();
      if (dd.length == 1)
        dd = "0" + dd;

      this.dateFrom = g.getFullYear().toString() + "-" + mm + "-" + dd;

      let m = (new Date().getMonth() + 1).toString();
      if (m.length == 1)
        m = "0" + m;
      let d = (new Date().getDate()).toString();
      if (d.length == 1)
        d = "0" + d;
      this.dateTo = new Date().getFullYear() + "-" + m + "-" + d;
    //}
  }

  getStatus(){
    this.statusSerevice.getAll().subscribe(x =>{
      //console.log(x);
      this.statusesFilter = x;
    })
  }
  getPermitTypes(){
    this.permitTypService.getAll().subscribe(x =>{
      //console.log(x);
      this.types = x;
    })
  }
  InitMultiselect() {
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'description',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 10,
      allowSearchFilter: this.ShowFilter,
      maxHeight: 120,
      closeDropDownOnSelection: false
    };
  }
  InitActiveMultiselect() {
    this.activeSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 10,
      allowSearchFilter: this.activeShowFilter,
      maxHeight: 120,
      closeDropDownOnSelection: false
    };
  }
  onItemSelect(item: any) { 
    this.statuses.push(item)
  }
  onDeSelect(item: any) { 
    this.statuses.forEach((element,index) => {
      if(element.id == item.id){
       this.statuses.splice(index,1);

      }
    });
  

  }
  onSelectAll(items: any) { 
    //console.log(items)
    this.statuses = items   
  }
  onActiveItemSelect(item: any){
    //console.log(item)
    this.isActive = item.id
  }
  onActiveSelectAll(items: any){
    this.isActives = items;
  }
  onActiveDeSelect(items: any){

  }

  reset(){
    location.reload();
  }

  checkKey(event){
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode == 13) {
      this.onSearch();
      return;
    }
  }

  onSearch(){

    
    this.filter.getData().subscribe(data => {
      this.carrierName = data.Carrier ? data.Carrier : '';
      this.permit_num = data.permit_num ? data.permit_num : '';
      this.vehicle_num = data.vehicle_num ? data.vehicle_num : '';
      this.dateFrom = data.dateFrom ? data.dateFrom : '';
      this.dateTo = data.dateTo ? data.dateTo : '';
      this.permit_type = data.permit_type ? data.permit_type : [];
      this.statuses = data.selectedItems ? data.selectedItems : [];
      

  });

  /* if (this.dateFrom === "" && this.dateTo === "")
  {
   return this.toastService.error('Expiry Date From and Expiry Date To are required for every query!','Expiry Date');
  }

    if(this.dateFrom !== undefined && this.dateTo === undefined){
        return this.toastService.error('Expiry Date To is required!','Expiry Date');
    }
    if(this.dateTo !== undefined && this.dateFrom === undefined){
      return this.toastService.error('Expiry Date From is required!','Expiry Date');
  } */
  if(this.carrierName === ""){
    this.carrierName = null;
  }
  if(this.permit_num === ""){
    this.permit_num = null;
  }
  if(this.vehicle_num === ""){
    this.vehicle_num = null;
  }
  
    let object = {
      CarrierName:this.carrierName,
      DateFrom:this.dateFrom,
      DateTo:this.dateTo,
      Permit_type:this.permit_type,
      Permit_num:this.permit_num,
      Vehicle_num:this.vehicle_num,
      Statuses: this.statuses,
      PageSize: this.pageSize,
      PageNumber:this.pageNumber

    }
    console.log('parameters', object);
    //postAllAppPermits
    this.gridload = true;
    this.applicationService.postAllAppPermits(object).subscribe((x:any) =>{
        if(x ==null){
            this.permits =[];
            this.Count = 0;
            this.gridload =false;
            return
        }
      this.permits = x.Items
      //alert(JSON.stringify(this.permits));
      console.log(this.permits);
      this.Count = x.Count;
     
      this.gridload =false;
    },error =>{
      this.gridload =false;

    });
  }
 
  getAppPermits(){
    this.gridload =true;
    this.applicationService.getAllAppPermits().subscribe((x:any) =>{     
      this.permits = x.Items
      this.Count = x.Count;  
      this.gridload =false;
    });    
  }
  pageSizeChange(){
    this.onSearch();
  }
  pageSizes() {
		return [5, 10, 25, 50, 100, 500, this.pageSizeMax];
  }
  onPage(page){
    this.pageNumber = page
    this.onSearch();
    return page;
  }
  pageSizeName(value) {
		if (value === this.pageSizeMax) return 'All';
		return value;
	}

}
